import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static identifier: string;
  static setIdentifier(identifier: string) {
    this.identifier = identifier;
  }

  static targets = ["input", "resultsContainer", "navigation"];
  static values = { searchUrl: String };

  declare readonly inputTarget: HTMLInputElement;
  declare readonly resultsContainerTarget: HTMLElement;
  declare readonly navigationTarget: HTMLElement;
  declare readonly searchUrlValue: string;

  private debounceTimer: ReturnType<typeof setTimeout> | null = null;

  search() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);

    this.debounceTimer = setTimeout(() => {
      this.performSearch();
    }, 300);
  }

  disconnect() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  }

  private async performSearch() {
    const query = this.inputTarget.value.trim();

    if (query.length < 2) {
      // Clear results and show navigation
      this.resultsContainerTarget.innerHTML = "";
      this.resultsContainerTarget.classList.add("hidden");
      this.navigationTarget.classList.remove("hidden");
      return;
    }

    // Show results container, hide navigation
    this.resultsContainerTarget.classList.remove("hidden");
    this.navigationTarget.classList.add("hidden");

    // Fetch search results
    const url = `${this.searchUrlValue}?q=${encodeURIComponent(query)}`;
    try {
      const response = await fetch(url, {
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
      });
      if (response.ok) {
        const html = await response.text();
        this.resultsContainerTarget.innerHTML = html;
      }
    } catch (e) {
      // Silently fail on network errors
    }
  }
}
